<template>
  <router-link :to="{ name: 'landingpage' }" class="home-btn">
    To home
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  </router-link>
</template>

<script>
  export default { name: 'HomeButton' }
</script>

<style scoped>
.home-btn {
  position: fixed;
  top: 1rem;
  right: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.6rem 1.3rem;
  background: linear-gradient(135deg, #5B8DB8 0%, #3D6A90 100%);
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 8px;
  text-decoration: none;
  box-shadow: 0 2px 10px rgba(91, 141, 184, 0.35);
  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  z-index: 100;
}
.home-btn:hover {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(91, 141, 184, 0.45);
}
.home-btn svg {
  width: 14px;
  height: 14px;
}
</style>
